import requester from '@/lib/axios';
import { CodeEditorFormFields } from '@/components/activities/elements/edit/CodeEditorElementEdit/CodeEditorForm';
import { CodeEditorActivityElement } from '@/models/_deprecated/ActivityElement';
import { CodeEditorActivity } from '@/models/CodeEditorActivity';
import { CodeValidationResult } from '@/models/CodeValidationResult';
import JsonApiResponse from '@/models/JsonApiResponse';

const BASE_URL = 'code-editor-activity';
const nestedUrl = (activityId: number) =>
  `activities/${activityId}/${BASE_URL}`;

export const listCodeEditorActivities = async () => {
  const { data } = await requester().get<JsonApiResponse<CodeEditorActivity>>(
    `${BASE_URL}/`,
  );

  return data;
};

export const getCodeEditorActivity = async (questionId: number) => {
  const { data } = await requester().get<CodeEditorActivity>(
    `${BASE_URL}/${questionId}/`,
  );

  return data;
};

export type ActivityValidationResult = {
  isValidated: boolean;
  executionResults: CodeValidationResult[];
};

export const validateCodeEditorActivity = async (
  activityId: number,
  questionId: number,
) => {
  const { data } = await requester().patch<ActivityValidationResult>(
    `${nestedUrl(activityId)}/${questionId}/validate/`,
  );

  return data;
};

export const createCodeEditorQuestionIntoActivity = async (
  activityId: number,
  body: Partial<CodeEditorActivityElement>,
) => {
  const { data } = await requester().post<CodeEditorActivity>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateCodeEditorQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<CodeEditorFormFields>,
) => {
  const { data } = await requester().patch<CodeEditorActivity>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteCodeEditorQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
